import { API_BASE_URLS } from './apiUrls';

export const contents = {
    // BASE URL
    BASE_URL: API_BASE_URLS.shared,
    // API TIMEOUT
    API_TIMEOUT: 30000 as const,

    // DATE FORMAT
    DATE_FORMAT: 'dd/mm/yyyy' as const,
    DATETIME_FORMAT: 'dd/mm/yyyy HH:mm:ss' as const,
    TIME_FORMAT: 'HH:mm:ss' as const,
    MAX_UOM_LIMIT: '9999.999',
    MAX_AMT_LIMIT: '999999999999999.999',

    // CONFIG KEYS
    SHIPMENT_INSPECTION_REQUIRED: 'shpInspcRqr',
    SUSPICIOUS_SHIPMENT_ALERT_ENABLED: 'st',
    SHIPMENT_VALUE_PROTECTION_ENABLED: 'insEnbld',
    PAPERLESS_FLAG: 'PZ',
    PIECES_CODE: 'PCS',

    // I18N KEYS
    I18N_KEYS: {
        SERVICE_OPERATION_FAILED: 'common.message.service_operation_failed',
    },
    I18N_DEFAULTS: {
        SERVICE_OPERATION_FAILED:
            'Service operation execution failed. Please try again or contact support.',
    },
};
